import { render } from "./ThinkingCard.vue?vue&type=template&id=a2df9274&scoped=true"
import script from "./ThinkingCard.vue?vue&type=script&lang=js"
export * from "./ThinkingCard.vue?vue&type=script&lang=js"

import "./ThinkingCard.vue?vue&type=style&index=0&id=a2df9274&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2df9274"]])

export default __exports__